import React, {Fragment, useMemo} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {Button, Col, Modal, Row} from "antd";
import {GUTTER_SM, MODAL_WIDTH_XL} from "../../../../styles/constants";
import EnhancedModal from "../../../../components/enhanced-modal";
import UnionQuery from "./components/UnionQuery";
import UnionTableSelect from "./components/UnionTableSelect";
import {connect} from "react-redux";
import {
    addOrModifySelectedTableDatasetBuilder,
    DatasetBuilderCleanSelectedTables,
    DatasetBuilderWizardClearQueryFetches,
    replaceQueryDatasetBuilder,
    selectCurrentTableDatasetBuilder
} from "./actions";
import {
    aliasIsInvalid,
    buildIndividualSQL,
    buildWholeSQL,
    sqlDoesNotContainBlacklistedKeywords
} from "./components/utils";

const mapStateToProps = state => {
    return {
        selectedTables: state.scenes.mappingHandler.datasetBuilder.unionModalProps.selectedTables,
        currentlySelectedTable: state.scenes.mappingHandler.datasetBuilder.unionModalProps.currentlySelectedTable,
        aliasCols: state.scenes.mappingHandler.datasetBuilder.unionModalProps.aliasCols,
        connections: state.scenes.mappingHandler.datasetBuilder.index.connections,
        connId: state.scenes.mappingHandler.datasetBuilder.index.connId,
        blackListQueryWord: state.config.dataManagement.blackListQueryWord,
    }
};

const mapDispatchToProps = dispatch => ({
    clearQueryFetches: (clearFilterStr) => dispatch(DatasetBuilderWizardClearQueryFetches(clearFilterStr)),
    cleanSelectedTables: () => dispatch(DatasetBuilderCleanSelectedTables()),
    replaceQuery: (query) => dispatch(replaceQueryDatasetBuilder(query)),
    setUserSelection: table => dispatch(selectCurrentTableDatasetBuilder(table)),
    addOrModifySelectedTable: () => dispatch(addOrModifySelectedTableDatasetBuilder())
});

const UnionBuilder = ({
                          isModalVisible,
                          onModalHide,
                          modalInfo,
                          t,
                          clearQueryFetches,
                          cleanSelectedTables,
                          replaceQuery,
                          selectedTables,
                          currentlySelectedTable,
                          setUserSelection,
                          addOrModifySelectedTable,
                          aliasCols,
                          connections,
                          connId,
                          blackListQueryWord,
                      }) => {
    const selectedConnection = useMemo(() => (connections || []).find(item => item.entityId === connId), [connections, connId]);
    const computedQuery = useMemo(() => buildWholeSQL(selectedTables, selectedConnection ? selectedConnection.realDbType || selectedConnection.dbType : null), [selectedTables, selectedConnection]);
    return (
        <EnhancedModal
            visible={isModalVisible}
            fullscreen
            onCancel={() => {
                clearQueryFetches();
                setUserSelection(null);
                if (!!currentlySelectedTable) {
                    return;
                }
                cleanSelectedTables();
                onModalHide();
            }}
            title={modalInfo ? t('components.datasetList.modals.union.title', {
                datasetName: currentlySelectedTable ? currentlySelectedTable.name : modalInfo.dataset ? modalInfo.dataset.name : ""
            }) : ""}
            width={MODAL_WIDTH_XL}
            footer={<Row type="flex" justify="end" align="middle" gutter={GUTTER_SM}>
                {!currentlySelectedTable && (<Fragment>
                    <Col>
                        <Button
                            onClick={() => {
                                clearQueryFetches();
                                onModalHide();
                            }
                            }
                        >
                            {t('commons.buttons.cancel.title')}
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            onClick={() => {
                                clearQueryFetches();
                                cleanSelectedTables();
                                setUserSelection(null);
                            }}
                        >
                            {t('scenes.mappingHandler.DatasetBuilder.wizard.step.query.clean.title')}
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            onClick={() => {
                                replaceQuery(computedQuery);
                                cleanSelectedTables();
                                onModalHide();
                            }}
                        >
                            {t('scenes.mappingHandler.DatasetBuilder.wizard.step.query.copy.title')}
                        </Button>
                    </Col>
                </Fragment>)}
                {!!currentlySelectedTable && (<Fragment>
                    <Col>
                        <Button
                            type="default"
                            onClick={() => {
                                clearQueryFetches();
                                setUserSelection(null);
                            }}
                        >
                            {t('commons.buttons.goBack.title')}
                        </Button>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            disabled={(aliasCols || []).length === 0}
                            onClick={() => {
                                if (!sqlDoesNotContainBlacklistedKeywords(
                                    buildIndividualSQL(aliasCols, currentlySelectedTable.tableViewId, "",
                                        selectedConnection ? selectedConnection.realDbType || selectedConnection.dbType : null), blackListQueryWord.split("|"), t)) return;
                                if (aliasIsInvalid(aliasCols)) {
                                    Modal.warning({
                                        title: t('commons.alerts.invalidForm.title'),
                                        content: t('commons.alerts.invalidForm.content')
                                    });
                                    return;
                                }
                                addOrModifySelectedTable();
                                clearQueryFetches();
                                setUserSelection(null);
                            }}
                        >
                            {t('commons.buttons.confirm.title')}
                        </Button>
                    </Col>
                </Fragment>)}
            </Row>}
        >
            {!currentlySelectedTable && <UnionTableSelect/>}
            {!!currentlySelectedTable && <UnionQuery/>}
        </EnhancedModal>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
)(UnionBuilder);
